import React, { useEffect, useState } from "react"
import SliderArrows from "./SliderArrows"
import { Swiper, SwiperSlide } from 'swiper/react';
import useIsMobile from "../Hooks/useIsMobile";
import('swiper/swiper.scss');
import BuyButtonContainer from "../Containers/BuyButton.container";
import { translate } from "../Services/translation";

const SLIDES_PER_VIEW_FALLBACK = 4;
var properties = null;

function ShouldShow(property) {
    return typeof properties != 'undefined' && properties != null && properties.includes(property);
}

const ProductSlider = props => {
    const { products, slidesPerView, showBuyButton } = props
    const SLIDES_PER_VIEW = slidesPerView || SLIDES_PER_VIEW_FALLBACK;
    const isMobile = useIsMobile()
    const [swiperInstance, setSwiperInstance] = useState()
    const [swiperCentered, setSwiperCentered] = useState()

    if (products != null && products.length > 0){
        properties = products[0].show;
    }

    const getProductCards = () => products.map((product, i) => {

        // Algolia product article number is for base product, we need to get article number for first variant to set on BuyButton
        let variantArticleNumber = showBuyButton && product.variants && product.variants.length > 0 ? product.variants[0].id : null;

        return <SwiperSlide className="product-slider-card" key={i}>
            {product.gtmProduct && <json-data class="gtm-product">{JSON.stringify(product.gtmProduct)}</json-data>}
            <a href={product.url ? product.url : ""}>
                <figure>
                    <img src={product.image1} className="first" />
                    {!isMobile && product.image2 && <img src={product.image2} className="second" />}
                </figure>
                <article>
                    <div className="product-slider-card__header">
                        <div>
                            {ShouldShow("brand") && <span className="product-slider-card__brand">{product.brand}</span>}
                            {ShouldShow("name") && <span className="product-slider-card__name">{product.styleName || product.name}</span>}
                        </div>
                    </div>
                    {ShouldShow("price") && <div className="product-slider-card__price">
                        {product.campaignPrice ? product.campaignPrice : product.price}
                        {product.campaignPrice && <>
                            <span className="product-slider-card__old-price">
                                {product.price}
                            </span>
                            <span className="product-slider-card__amount-off">
                                {product.discountPercent}
                            </span>
                        </>}
                        {!product.price && <span dangerouslySetInnerHTML={{__html: "&nbsp;"}}></span>}
                    </div>}
                    <meta content={product.description} />
                </article>
            </a>

            {showBuyButton && variantArticleNumber && (
                <div className="product-slider-card__buy-button swiper-no-swiping">
                    <BuyButtonContainer
                        label={translate("buy-button.add")}
                        hideVariantSelect={true}
                        isInStock={product.inStock}
                        cssClass="btn btn--small btn--secondary"
                        articleNumber={variantArticleNumber} />
                </div>
            )}
        </SwiperSlide>
    });

    const limitSlidesPerView = (requestedCount) => {
        // If slides per view is passed in props, we use it as max value
        if(slidesPerView){
            return Math.min(requestedCount, slidesPerView);
        }
        return requestedCount;
    }

    const settings = {
        spaceBetween: 1,
        slidesPerView: SLIDES_PER_VIEW,
        freeModeSticky: true,
        resistanceRatio: 0,
        threshold: 6,
        noSwiping: true,
        loop: true,
        onSwiper: instance => {
            setSwiperInstance(instance)
            setSwiperCentered(instance.virtualSize <= instance.size)
        },
        onResize: instance => {
            setSwiperCentered(instance.virtualSize <= instance.size)
        },
        breakpoints: {
            0: {
                slidesPerView: limitSlidesPerView(1.2),
                centeredSlides: true,
            },
            300: {
                slidesPerView: limitSlidesPerView(2.2),
            },
            768: {
                slidesPerView: limitSlidesPerView(SLIDES_PER_VIEW),
                centeredSlides: false,
            },
            1440: {
                slidesPerView: limitSlidesPerView(SLIDES_PER_VIEW+1),
                centeredSlides: false,
            }
        } 
    }

    return <div className={swiperCentered ? "product-slider--centered" : ""}>
        <Swiper {...settings}>
            {getProductCards()}
            <SliderArrows 
                onLeftClick={() => swiperInstance && swiperInstance.slidePrev()} 
                onRightClick={() => swiperInstance && swiperInstance.slideNext()} 
                rightVisible={() => swiperInstance && swiperInstance.realIndex <= (products.length - 1 - SLIDES_PER_VIEW)}
                leftVisible={() => swiperInstance && swiperInstance.realIndex > 0}
            />
        </Swiper>
    </div>
}

export default ProductSlider
